import { DROPDOWN_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../fabrics/createDisplayName";

export const createDisplayNameForDropdownElement = createDisplayName(
    DROPDOWN_DISPLAY_NAME,
);
